// Must be the first import so Sentry initialises before App's module graph
// evaluates — see src/sentry.ts and BLUM-6399.
import './sentry';

import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/App';

// import * as serviceWorker from './serviceWorker';

declare module '@material-ui/core/styles/createPalette' {
  interface CommonColors {
    black: string;
    white: string;
    green: string;
    red: string;
    neutral: string;
  }
  interface Palette {
    border: string;
  }
}

declare module '@material-ui/core/styles/createSpacing' {
  interface Spacing {
    unit: string;
  }
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
// serviceWorker.unregister();
